import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Moon, Sun } from 'lucide-react';

const GeneralTab = ({ darkMode, toggleDarkMode }) => {
  return (
    <div className="space-y-6">
      <Card className="rounded-2xl border-[#E0D6C8]">
        <CardHeader>
          <CardTitle className="text-xl font-['Manrope']">Appearance</CardTitle>
          <CardDescription>Customize the look and feel of the app</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex items-center justify-between p-4 rounded-xl bg-[#F3EFE9]/50">
            <div className="flex items-center gap-3">
              {darkMode ? <Moon className="w-5 h-5 text-[#C4A44A]" /> : <Sun className="w-5 h-5 text-[#E07A5F]" />}
              <div>
                <p className="font-medium text-sm">Dark Mode</p>
                <p className="text-xs text-[#888]">
                  {darkMode ? 'Emerald & gold dark theme active' : 'Switch to dark theme for low-light environments'}
                </p>
              </div>
            </div>
            <Button
              data-testid="dark-mode-toggle"
              variant={darkMode ? "default" : "outline"}
              size="sm"
              onClick={toggleDarkMode}
              className={darkMode 
                ? "bg-[#5C4023] hover:bg-[#4A331C] rounded-full" 
                : "rounded-full"
              }
            >
              {darkMode ? <><Sun className="w-4 h-4 mr-1" /> Light Mode</> : <><Moon className="w-4 h-4 mr-1" /> Dark Mode</>}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default GeneralTab;
